import React from 'react';

// TODO: change this to null on next major semver bump
const NavigationContext = React.createContext(undefined);

export default NavigationContext;
